var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DrawerBody, DrawerHeader, FormController, FormLabel, Input, Typography, } from '@one-thd/sui-atomic-components';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { AddOnlineReceipt } from '../../../../api/oms/order-history';
import { onlineErrors } from '../../../../constants/receipt-error';
import { useCommonContext } from '../../../../hooks/useContexts';
import { addSlash, makeOnlineRequestBody, } from '../../../../utils/order-history';
import { setHOrderError } from '../../../../utils/purchase-history/analytics';
import { AddReceiptDrawerFooter } from './AddReceiptDrawerFooter';
export var OnlineReceiptForm = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var closeDrawer = _a.closeDrawer, setAlertState = _a.setAlertState, setDrawerStepper = _a.setDrawerStepper, svocId = _a.svocId;
    var _m = useState({
        orderNumber: '',
        orderDate: '',
        email: '',
    }), inputError = _m[0], setInputError = _m[1];
    var _o = useState(false), isLoading = _o[0], setLoading = _o[1];
    var isMobile = useCommonContext().isMobile;
    var _p = useForm({
        mode: 'onBlur',
        defaultValues: {
            email: '',
            orderDate: '',
            orderNumber: '',
            tryAgain404: false,
            apiError: false,
        },
    }), clearErrors = _p.clearErrors, errors = _p.formState.errors, handleSubmit = _p.handleSubmit, register = _p.register, reset = _p.reset, watch = _p.watch, setValue = _p.setValue, setError = _p.setError;
    var watchEmail = watch('email');
    var watchOrderDate = watch('orderDate');
    var watchOrderNumber = watch('orderNumber');
    useEffect(function () {
        if ((watchOrderNumber === null || watchOrderNumber === void 0 ? void 0 : watchOrderNumber.length) === 10 &&
            (watchOrderNumber === null || watchOrderNumber === void 0 ? void 0 : watchOrderNumber.match(/[W,w,C,c,H,h][\d,\w]\d{8}$/))) {
            setInputError(function (prevState) { return (__assign(__assign({}, prevState), { orderNumber: 'success' })); });
            clearErrors('orderNumber');
        }
        if ((inputError === null || inputError === void 0 ? void 0 : inputError.orderNumber) === 'success' &&
            (watchOrderNumber === null || watchOrderNumber === void 0 ? void 0 : watchOrderNumber.length) !== 10) {
            setInputError(function (prevState) { return (__assign(__assign({}, prevState), { orderNumber: 'error' })); });
            setError('orderNumber', { type: 'invalid', message: 'invalid entry' });
        }
    }, [watchOrderNumber]);
    useEffect(function () {
        if ((watchOrderDate === null || watchOrderDate === void 0 ? void 0 : watchOrderDate.length) === 8) {
            var tempYear = watchOrderDate === null || watchOrderDate === void 0 ? void 0 : watchOrderDate.split('/');
            var tempDate = new Date("".concat(tempYear[2] < '20' ? '19' : '20').concat(tempYear[2], "/").concat(tempYear[0], "/").concat(tempYear[1]));
            if (Number.isNaN(tempDate.getTime())) {
                setInputError(function (prevState) { return (__assign(__assign({}, prevState), { orderDate: 'error' })); });
                setError('orderDate', { type: 'invalid', message: 'invalid entry' });
                return;
            }
            setInputError(function (prevState) { return (__assign(__assign({}, prevState), { orderDate: 'success' })); });
            clearErrors('orderDate');
            return;
        }
        if ((inputError === null || inputError === void 0 ? void 0 : inputError.orderDate) === 'success' && (watchOrderDate === null || watchOrderDate === void 0 ? void 0 : watchOrderDate.length) !== 8) {
            setInputError(function (prevState) { return (__assign(__assign({}, prevState), { orderDate: 'error' })); });
            setError('orderDate', { type: 'invalid', message: 'invalid entry' });
        }
    }, [watchOrderDate]);
    useEffect(function () {
        if ((watchEmail === null || watchEmail === void 0 ? void 0 : watchEmail.length) > 6 && (watchEmail === null || watchEmail === void 0 ? void 0 : watchEmail.includes('.'))) {
            if (watchEmail === null || watchEmail === void 0 ? void 0 : watchEmail.includes('@')) {
                setInputError(function (prevState) { return (__assign(__assign({}, prevState), { email: 'success' })); });
                clearErrors('email');
            }
            else {
                setInputError(function (prevState) { return (__assign(__assign({}, prevState), { email: 'error' })); });
                setError('email', { type: 'invalid', message: 'invalid entry' });
            }
        }
        if ((inputError === null || inputError === void 0 ? void 0 : inputError.email) === 'success' && (watchEmail === null || watchEmail === void 0 ? void 0 : watchEmail.length) < 7) {
            setInputError(function (prevState) { return (__assign(__assign({}, prevState), { email: 'error' })); });
            setError('email', { type: 'invalid', message: 'invalid entry' });
        }
    }, [watchEmail]);
    var onFormSubmit = function (_a) {
        var _b = _a.email, email = _b === void 0 ? '' : _b, _c = _a.orderDate, orderDate = _c === void 0 ? '' : _c, _d = _a.orderNumber, orderNumber = _d === void 0 ? '' : _d;
        return __awaiter(void 0, void 0, void 0, function () {
            var request, response, status_1, error_1, hCode, desc, errorDescription, code, errorMessage;
            var _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
            return __generator(this, function (_w) {
                switch (_w.label) {
                    case 0:
                        clearErrors();
                        _w.label = 1;
                    case 1:
                        _w.trys.push([1, 4, 5, 6]);
                        request = void 0;
                        if (!(email && orderDate && orderNumber && svocId)) return [3 /*break*/, 3];
                        setLoading(true);
                        request = makeOnlineRequestBody(svocId, orderNumber, orderDate, email);
                        return [4 /*yield*/, AddOnlineReceipt(request)];
                    case 2:
                        response = _w.sent();
                        status_1 = response ? response.status : null;
                        if (status_1 === null) {
                            setError('tryAgain404', {
                                type: 'failed',
                                message: 'failed request',
                            });
                            return [2 /*return*/];
                        }
                        closeDrawer();
                        reset();
                        setAlertState({
                            alertMessage: "You've successfully added an online receipt to your account. View Order ".concat(orderNumber),
                            status: 'success',
                        });
                        _w.label = 3;
                    case 3: return [3 /*break*/, 6];
                    case 4:
                        error_1 = _w.sent();
                        hCode = 'B2B_ADD_ONLINE_RECEIPT_ERR_8309';
                        desc = (_g = (_f = (_e = error_1 === null || error_1 === void 0 ? void 0 : error_1.errors) === null || _e === void 0 ? void 0 : _e.error) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.description;
                        errorDescription = (_l = (_k = (_j = (_h = error_1.response) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.error) === null || _k === void 0 ? void 0 : _k[0]) === null || _l === void 0 ? void 0 : _l.description;
                        code = (_p = (_o = (_m = error_1 === null || error_1 === void 0 ? void 0 : error_1.errors) === null || _m === void 0 ? void 0 : _m.error) === null || _o === void 0 ? void 0 : _o[0]) === null || _p === void 0 ? void 0 : _p.code;
                        if (code === hCode) {
                            setHOrderError(desc !== null && desc !== void 0 ? desc : '');
                            return [2 /*return*/];
                        }
                        if (error_1.response.status === 500) {
                            setError('tryAgain404', {
                                type: 'failed',
                                message: 'failed request',
                            });
                            return [2 /*return*/];
                        }
                        errorMessage = void 0;
                        try {
                            errorMessage = (_v = (_u = (_t = (_s = (_r = (_q = JSON.parse(errorDescription)) === null || _q === void 0 ? void 0 : _q.addReceiptResponse) === null || _r === void 0 ? void 0 : _r.receipts) === null || _s === void 0 ? void 0 : _s[0]) === null || _t === void 0 ? void 0 : _t.errors) === null || _u === void 0 ? void 0 : _u[0]) === null || _v === void 0 ? void 0 : _v.description;
                        }
                        catch (err) {
                            errorMessage =
                                'We were unable to retrieve your receipt details. Refresh the page and try again.';
                        }
                        setError('apiError', {
                            type: 'failed',
                            message: errorMessage,
                        });
                        return [3 /*break*/, 6];
                    case 5:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    var handleButtonClick = function () {
        clearErrors('tryAgain404');
        handleSubmit(onFormSubmit)();
    };
    return (React.createElement("div", { "data-testid": "onlineReceiptForm", className: "sui-flex sui-flex-col sui-h-full" },
        React.createElement(DrawerHeader, { title: "Add Online Receipt", onClose: closeDrawer, onBack: function () { return setDrawerStepper && setDrawerStepper(0); } }),
        React.createElement(DrawerBody, { style: { height: isMobile ? '65vh' : '' } },
            React.createElement(Typography, null, "Please enter the following details found in your order:"),
            React.createElement(FormController, { className: "sui-mt-6", fullWidth: true, status: inputError.orderNumber || ((errors === null || errors === void 0 ? void 0 : errors.orderNumber) && 'error') },
                React.createElement(FormLabel, { htmlFor: "orderNumber" },
                    "Order Number",
                    React.createElement("sup", null, "*")),
                React.createElement(Input, __assign({ "aria-describedby": "orderNumber-input", fullWidth: true, id: "orderNumber", inputProps: {
                        maxLength: 10,
                    } }, register('orderNumber', {
                    required: true,
                    minLength: 9,
                    pattern: /[W,w,C,c,H,h][\d,\w]\d{8}$/,
                    onChange: function (event) {
                        return setValue('orderNumber', event.target.value.toUpperCase());
                    },
                    onBlur: function (event) {
                        return setValue('orderNumber', event.target.value.toUpperCase());
                    },
                }), { placeholder: "W123456789" })),
                (inputError.orderNumber === 'error' || errors.orderNumber) && (React.createElement(Typography, { variant: "body-xs", color: "danger" },
                    ((_b = errors === null || errors === void 0 ? void 0 : errors.orderNumber) === null || _b === void 0 ? void 0 : _b.type) === 'tryAgain' &&
                        onlineErrors.orderNumberNotFound,
                    (['required', 'minLength', 'invalid', 'pattern'].includes((_d = (_c = errors === null || errors === void 0 ? void 0 : errors.orderNumber) === null || _c === void 0 ? void 0 : _c.type) !== null && _d !== void 0 ? _d : 'invalid') ||
                        inputError.orderNumber === 'error') &&
                        onlineErrors.orderNumberInvalidFormat))),
            React.createElement(FormController, { className: "sui-mt-6", fullWidth: true, status: inputError.orderDate || ((errors === null || errors === void 0 ? void 0 : errors.orderDate) && 'error') },
                React.createElement(FormLabel, { htmlFor: "orderDate" },
                    "Order Date",
                    React.createElement("sup", null, "*")),
                React.createElement(Input, __assign({ "aria-describedby": "orderDate-input", fullWidth: true, id: "orderDate", inputProps: {
                        maxLength: 8,
                    } }, register('orderDate', {
                    required: true,
                    minLength: 5,
                    pattern: /^(\d{2})\/(\d{2})\/(\d{2})$/,
                    onChange: function (event) {
                        return setValue('orderDate', addSlash(event.target.value));
                    },
                    onBlur: function (event) {
                        return setValue('orderDate', addSlash(event.target.value));
                    },
                }), { placeholder: "MM/DD/YY" })),
                (inputError.orderDate === 'error' || errors.orderDate) && (React.createElement(Typography, { variant: "body-xs", color: "danger" },
                    ((_e = errors === null || errors === void 0 ? void 0 : errors.orderDate) === null || _e === void 0 ? void 0 : _e.type) === 'tryAgain' &&
                        onlineErrors.orderDateNotFound,
                    (['required', 'minLength', 'invalid', 'pattern'].includes((_g = (_f = errors === null || errors === void 0 ? void 0 : errors.orderDate) === null || _f === void 0 ? void 0 : _f.type) !== null && _g !== void 0 ? _g : 'invalid') ||
                        inputError.orderDate === 'error') &&
                        onlineErrors.orderDateInvalidFormat))),
            React.createElement(FormController, { className: "sui-mt-6", fullWidth: true, status: inputError.email || ((errors === null || errors === void 0 ? void 0 : errors.email) && 'error') },
                React.createElement(FormLabel, { htmlFor: "email" },
                    "Email on Order",
                    React.createElement("sup", null, "*")),
                React.createElement(Input, __assign({ "aria-describedby": "email-input", fullWidth: true, id: "email" }, register('email', {
                    required: true,
                    minLength: 6,
                    pattern: /^.+@[^.].*\.[a-z]{2,}$/,
                    onChange: function (event) {
                        return setValue('email', event.target.value);
                    },
                    onBlur: function (event) {
                        return setValue('email', event.target.value);
                    },
                }), { placeholder: "you@domain.com" })),
                (inputError.email === 'error' || errors.email) && (React.createElement(Typography, { variant: "body-xs", color: "danger" },
                    ((_h = errors === null || errors === void 0 ? void 0 : errors.email) === null || _h === void 0 ? void 0 : _h.type) === 'tryAgain' && onlineErrors.emailNotFound,
                    (['required', 'minLength', 'invalid', 'pattern'].includes((_k = (_j = errors === null || errors === void 0 ? void 0 : errors.email) === null || _j === void 0 ? void 0 : _j.type) !== null && _k !== void 0 ? _k : 'invalid') ||
                        inputError.email === 'error') &&
                        onlineErrors.emailInvalidFormat))),
            errors.tryAgain404 && (React.createElement("div", { className: "sui-mt-6" },
                React.createElement(Typography, { color: "danger" }, onlineErrors.api404Error))),
            errors.apiError && (React.createElement("div", { className: "sui-mt-6" },
                React.createElement(Typography, { color: "danger" }, (_l = errors === null || errors === void 0 ? void 0 : errors.apiError) === null || _l === void 0 ? void 0 : _l.message)))),
        React.createElement(AddReceiptDrawerFooter, { closeDrawer: closeDrawer, handleButtonClick: handleButtonClick, isLoading: isLoading, primaryButtonText: "Add Online Receipt", reset: reset, secondaryButtonText: "Cancel" })));
};
